import React from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import { useOrgAuth } from '../contexts/OrgAuthContext';

function OrgProtectedRoute() {
  const { currentUser, loading } = useOrgAuth();
  const { orgId } = useParams();

  if (loading) {
    return (
      <div className="bb-loading-screen">
        <div className="bb-loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to={`/BespokeBridge/${orgId}/admin/login`} replace />;
  }

  if (orgId && currentUser.orgId !== orgId) {
    return <Navigate to={`/BespokeBridge/${orgId}/admin/login`} replace />;
  }

  return <Outlet />;
}

export default OrgProtectedRoute;
